import type { State } from '../types';
import type { OperationType } from '../../types';

export const getCurrentOperationTypesSelector = (state: State): OperationType[] | null => {
  const selectedProductIds = Object.keys(state.selectedProducts);
  if (!selectedProductIds || !selectedProductIds.length) {
    return null;
  }
  const operationTypeSet = new Set<OperationType>();
  selectedProductIds.forEach((selectedProductId) => {
    operationTypeSet.add(state.products[selectedProductId]?.operationType);
  });
  return Array.from(operationTypeSet);
};
